import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import TVBox from '../TVBox';

const CardStyled = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`

const TooltipStyled = styled(Tooltip)`
	position: absolute;
	top: 0;
	right: 0;
	margin: 5px;
`

const TVBoxStyled = styled(TVBox)`
	margin: 20px 0;
	transform: scale(1);
`

const Label = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 18px;
	font-weight: 700;
	margin-bottom: 24px;
`
const Alert = styled(Icon)`
	font-size: 27px;
`
//TODO: create info card models
const MainCard = ({
  label,
	count,
	image,
  AlertText,
  ...other
}) => {


  return (
		<CardStyled {...other}>
			{
				AlertText &&	
				<TooltipStyled title={AlertText} placement="bottom">
					<Alert color='secondary' >error_outline</Alert>
				</TooltipStyled>
			}
			<TVBoxStyled url={image}/>
			<Label>{label}</Label>
    </CardStyled>
  )
}

MainCard.propTypes = {
  label: PropTypes.string,
  count: PropTypes.number,
	AlertText: PropTypes.string,
	image: PropTypes.string,
};

MainCard.defaultProps = {
    
};

export default MainCard;
